import { Logo } from "./Logo.tsx";

export function NavBar() {
  return (
    <header
      className={"flex p-2 items-center bg-white shadow-md shadow-slate-200/30"}
    >
      <Logo />
    </header>
  );
}
